import Enums from 'utils/EnumsManager';
import { toFixedDecimal } from 'utils/mathUtil';

const { AGGREGATES } = Enums.DROPZONES;
const { AGGREGATES_ZONE_TAG_ACTIONS, PREVIEW } = Enums.REPORTS;
const { ROWSPERGROUP } = PREVIEW;

const getGroupSumByColumn = (rangeData, key) => {
  const values = rangeData.map(gd => gd[key]);
  return values.reduce((acc, val) => acc + Number(val), 0);
};

const getRangeData = (data, index) => {
  const min = index * ROWSPERGROUP;
  const max = min + ROWSPERGROUP;
  return data.filter((record, i) => i >= min && i < max);
};

// Calculate values (sum, avg) for each columns aggregate zone
const calcSummary = (data, columns, index) => {
  const rangeData = getRangeData(data, index);

  const aggregatesColumns = columns.filter(col => col.belongTo === AGGREGATES);
  const summaryData = aggregatesColumns.map(ac => {
    const sum = getGroupSumByColumn(rangeData, ac.name);
    return {
      id: ac.id,
      label: ac.label,
      sum:
        ac.actions.indexOf(AGGREGATES_ZONE_TAG_ACTIONS[0]) > -1
          ? toFixedDecimal(sum)
          : null,
      avg:
        ac.actions.indexOf(AGGREGATES_ZONE_TAG_ACTIONS[1]) > -1
          ? toFixedDecimal(sum / ROWSPERGROUP)
          : null
    };
  });
  return {
    data: summaryData,
    count: ROWSPERGROUP
  };
};

export { calcSummary };



// WEBPACK FOOTER //
// ./src/views/ReportPreview/utils/summaryUtils.js